import DataService from './DataService'

export default {
  async fetchSegmentData(segmentName) {
    return DataService.get(`/segments/${segmentName}.xml`, 'xml')
  }
}
